import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import api from "../../../api/api"

export const getBalance = createAsyncThunk(
  "balance/getBalance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.events.getBalance()
      return res.data
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong")
    }
  },
)

// Initial State
const initialState = {
  isBalanceLoading: false,
  balanceError: null,
  balance: 0,
}

// Slice
const balanceSlice = createSlice({
  name: "balance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBalance.pending, (state) => {
        state.isBalanceLoading = true
        state.balanceError = null
      })
      .addCase(getBalance.rejected, (state, action: PayloadAction<any>) => {
        state.isBalanceLoading = false
        state.balanceError = action.payload
      })
      .addCase(getBalance.fulfilled, (state, action: PayloadAction<any>) => {
        ;(state.isBalanceLoading = false),
          (state.balanceError = null),
          (state.balance = action.payload.balance)
      })

    // ... rest of the code ...
  },
})

export default balanceSlice.reducer
